import { z } from "zod";

export const refreshResponseSchema = z
  .object({
    access_token: z.string().min(1),
    access_token_expires_at: z.string().min(1),
  })
  .strict()
  .transform((response) => ({
    accessToken: response.access_token,
    accessTokenExpiresAt: response.access_token_expires_at,
  }));
